import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { serverUtilities } from "services/serverutilities.service";
import ScheduleScreen from "./homeshedule";
import { FileText, Play, File, ClipboardList, Clock } from 'lucide-react';
const ContentView = () => {
  const location = useLocation();
  const { id, courseName } = location.state || {};
  const [courseContent, setCourseContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourseContent = async () => {
      try {
        const apiData = await serverUtilities.getCourseContent('0', id);
        setCourseContent(apiData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching course content:', error);
        setLoading(false);
      }
    };
    
    fetchCourseContent();
  }, [id]);
const getContentIcon = (contentItem) => {
  const iconStyle = { width: '20px', height: '20px', color: '#555' };
  
 
  if (contentItem.primary_content === 'VIDEO' || contentItem.CotnentURL?.includes('youtube') || contentItem.CotnentURL?.includes('vimeo')) {
    return (
      <svg style={iconStyle} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
      </svg>
    );
  }
  

  if (contentItem.primary_content === 'PDF') {
    return (
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text-icon lucide-file-text"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>
    );
  }
  
  if (contentItem.primary_content === 'TEST' || contentItem.description?.toLowerCase().includes('test') || contentItem.description?.toLowerCase().includes('quiz')) {
    return (
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-open-text-icon lucide-book-open-text"><path d="M12 7v14"/><path d="M16 12h2"/><path d="M16 8h2"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/><path d="M6 12h2"/><path d="M6 8h2"/></svg>
    );
  }
  
  return (
    <svg style={iconStyle} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M21 8v12.993c0 .556-.449 1.007-1.007 1.007h-15.986c-.558 0-1.007-.45-1.007-1.007v-17.986c0-.557.449-1.007 1.007-1.007h8.994l5.002 5.002zm-9 1h-7v12h14v-10h-7v-2zm5-4.994v3.994h3.993l-3.993-3.994z" />
    </svg>
  );
};
  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!courseContent) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>No course content available</div>;
  }

  const { buckets } = courseContent;

  return (
    <div style={{
      padding: '20px',
      maxWidth: '1400px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'row',
      gap: '30px',
      alignItems: 'flex-start'
    }}>
      {/* Left Column - Content View */}
      <div style={{
        flex: '2',
        minWidth: '0'
      }}>
        {/* <h1 style={{ 
          color: '#333', 
          marginBottom: '30px', 
          borderBottom: '2px solid #eee', 
          paddingBottom: '10px' 
        }}>
          {courseName || 'Course Content'}
        </h1> */}
        
        <div style={{ marginBottom: '40px' }}>
          {Object.keys(buckets).map(bucketId => {
            const bucket = buckets[bucketId];
            return (
              <div 
                key={bucketId}
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  padding: '15px',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                  backgroundColor: '#fff',
                  marginBottom: '20px'
                }}
              >
                <h2 style={{ 
                  color: '#2c3e50', 
                  marginTop: '0',
                  paddingBottom: '10px',
                  borderBottom: '1px solid #eee'
                }}>
                  {bucket.bucket_name}
                </h2>
                
                {Object.keys(bucket.groups).map(groupId => {
                  const group = bucket.groups[groupId];
                  return (
                    <div key={groupId} style={{ marginTop: '20px' }}>
                      <h3 style={{ 
                        color: '#34495e', 
                        marginBottom: '10px',
                        fontSize: '16px'
                      }}>
                        {group.group_name}
                      </h3>
                      
                      {group.content_json && group.content_json.length > 0 ? (
                        <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
                          {group.content_json.map((contentItem, index) => (
                           <li 
  key={index} 
  style={{
    padding: '10px',
    borderBottom: '1px solid #eee',
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }}
>
  {/* Icon based on content type */}
  {getContentIcon(contentItem)}
  
  <div>
    <div style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>
      {contentItem.description || `Item ${index + 1}`}
    </div>
    {contentItem.duration && (
      <div style={{ color: '#666', fontSize: '12px', marginTop: '3px' }}>
        Duration: {contentItem.duration}
      </div>
    )}
  </div>
</li>
                          ))}
                        </ul>
                      ) : (
                        <div style={{ color: '#999', fontStyle: 'italic' }}>No content items in this group</div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>

      {/* Right Column - Schedule Screen */}
      <div style={{
        flex: '1',
        position: 'sticky',
        top: '20px',
        minWidth: '0'
      }}>
        <ScheduleScreen 
          navigation={''} 
          data={''}
          style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '15px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            backgroundColor: '#fff'
          }}
        />
      </div>

      {/* Mobile View - Schedule Screen at bottom */}
      <div style={{
        display: 'none',
        width: '100%',
        marginTop: '20px'
      }}>
        <ScheduleScreen 
          navigation={''} 
          data={''}
          style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '15px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            backgroundColor: '#fff'
          }}
        />
      </div>
    </div>
  );
};

export default ContentView;